// Lazy load images
import Lazyload from 'vanilla-lazyload';
import Alpine from 'alpinejs';
import MicroModal from 'micromodal';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Rellax from 'rellax';

// main nav dropdown - must be defined before Alpine.start()
window.navDropdown = function () {
    return {
        isOpen: false,
        trigger: {
            ['@click']() {
                this.isOpen = !this.isOpen;
            },
            [':aria-expanded']() {
                return this.isOpen.toString();
            },
            [':class']: '{ "text-secondary" : isOpen }',
        },
        childMenu: {
            [':aria-expanded']() {
                return this.isOpen.toString();
            },
            ['x-transition:enter']: 'transition duration-200 ease-in',
            ['x-transition:enter-start']: 'opacity-0',
            ['x-transition:enter-end']: 'opacity-100',
            ['x-transition:leave']: 'transition duration-200 ease-in',
            ['x-transition:leave-start']: 'opacity-100',
            ['x-transition:leave-end']: 'opacity-0',
            ['x-show']() {
                return this.isOpen;
            },
        },
        icon: {
            [':class']: '{ "transform rotate-180": isOpen }',
        },
    };
};

// Initialize Alpine
window.Alpine = Alpine;
Alpine.start();

// Create Lazy load instance
var lazyLoadInstance = new Lazyload({
    elements_selector: '.lazy',
    // ... more custom settings?
});

// Modals
MicroModal.init({
    disableScroll: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
});

// Rellax.js for testimonials
const rellaxElements = '.rellax';

if (document.querySelectorAll(rellaxElements).length) {
    const testimonialRellax = new Rellax(rellaxElements, {
        center: true,
    });
}

//-------------------------------------------
// Infield labels for form inputs
//-------------------------------------------
const allInfieldLabels = document.querySelectorAll('.infield-label');

const infieldClassChange = (event) => {
    let parent = event.target.parentNode;

    if (parent.classList.contains('infield-label')) {
        if (event.target.value !== '') {
            parent.classList.add('has-value');
        } else {
            parent.classList.remove('has-value');
        }
    }
};

allInfieldLabels.forEach((item) => {
    let field = item.querySelector('input,textarea');

    if (field) {
        if (field.value !== '') {
            item.classList.add('has-value');
        }

        field.addEventListener('change', infieldClassChange);

        field.addEventListener('blur', infieldClassChange);
    }
});

//-------------------------------------------
// Fix anchor links since firefox is dumb
//-------------------------------------------
/* Scroll to anchor */
function pgshow(e) {
    var elId = window.location.hash;
    if (elId.length > 1) {
        let el = document.getElementById(elId.substr(1));
        if (el) el.scrollIntoView(true);
    }
}
// pageshow fires after load and on Back/Forward
window.addEventListener('pageshow', pgshow);

// ===================================================
// Testimonial sliders
// ===================================================
const testimonialSliders = document.querySelectorAll(
    '[data-testimonial-slider]',
);
testimonialSliders.forEach((item) => {
    new Swiper(item.querySelector('.swiper'), {
        slidesPerView: 1,
        centeredSlides: true,
        grabCursor: true,
        spaceBetween: 20,
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 10000,
        },
        navigation: {
            nextEl: item.querySelector('.swiper-button-next'),
            prevEl: item.querySelector('.swiper-button-prev'),
        },
        pagination: {
            el: item.querySelector('.swiper-pagination'),
        },
        modules: [Navigation, Pagination, Autoplay],
    });
});
